export default __webpack_public_path__ + "static/media/custom3.7030bcb8.jpg";